import { useMemo, useState } from 'react'

import {
  CookieConsentPreferencesModal,
  CookieConsentWrapper,
  DefaultApps,
} from '@tribeplatform/react-components/Apps'
import { T } from '@tribeplatform/react-components/i18n'
import {
  useApp,
  useAuthMember,
  useNetwork,
} from '@tribeplatform/react-sdk/hooks'
import { ActionPanel } from '@tribeplatform/react-ui-kit/ActionPanel'
import { Button } from '@tribeplatform/react-ui-kit/Button'

import { ChangeEmail } from './ChangeEmail.js'
import { ChangePassword } from './ChangePassword.js'
import { ConnectedAccounts } from './ConnectedAccounts.js'
import { DeleteAccount } from './DeleteAccount.js'
import { LanguageSettings } from './LanguageSettings.js'
import { SupportAccess } from './SupportAccess.js'
import { TimezoneSettings } from './Timezone/TimezoneSettings.js'
import { VerifyAccount } from './VerifyAccount.js'

export const AccountSettings = () => {
  const { data: network } = useNetwork()
  const [isCookieModalOpen, setIsCookieModalOpen] = useState(false)

  const { data: member } = useAuthMember()

  const { data: cookieConsentApp, isInitialLoading } = useApp({
    variables: {
      slug: DefaultApps.CookieConsentManager,
    },
  })
  const isCookieAppInstalled = useMemo(
    () => Boolean(!isInitialLoading && cookieConsentApp?.installed),
    [cookieConsentApp, isInitialLoading],
  )

  return (
    <>
      <VerifyAccount />
      <ChangeEmail />
      <LanguageSettings />
      <TimezoneSettings />
      {!network?.activeSso && <ChangePassword />}
      <ConnectedAccounts member={member} />
      {isCookieAppInstalled && (
        <>
          <ActionPanel
            title={<T defaultMessage="Cookies" id="Generics.Cookies" />}
            description={
              <T
                defaultMessage="Manage your cookie consent settings"
                id="Settings.CookieConsent.Description"
              />
            }
            placement="trailing-top"
          >
            <Button
              variant="secondaryNeutral"
              size="lg"
              onClick={() => setIsCookieModalOpen(true)}
            >
              <T defaultMessage="Manage" id="Generics.Manage" />
            </Button>
          </ActionPanel>
          <CookieConsentWrapper>
            {isCookieModalOpen && (
              <CookieConsentPreferencesModal
                isOpen={isCookieModalOpen}
                onClose={() => setIsCookieModalOpen(false)}
              />
            )}
          </CookieConsentWrapper>
        </>
      )}
      <SupportAccess />
      <DeleteAccount />
    </>
  )
}
